export default __webpack_public_path__ + "static/image8-2da0db96fc875d5901b11d18f5693fba.jpg";